
    import './styles.scoped.css';
    export default {
  "help-panel": "awsui_help-panel_1d237_1aqk5_9",
  "loading": "awsui_loading_1d237_1aqk5_179",
  "header": "awsui_header_1d237_1aqk5_184",
  "with-toolbar": "awsui_with-toolbar_1d237_1aqk5_202",
  "content": "awsui_content_1d237_1aqk5_221",
  "footer": "awsui_footer_1d237_1aqk5_273"
};
  